var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCare2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#131927"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3409_14608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 41C42.1733 41 44.0933 41.52 45.6533 42.2C47.0933 42.84 48 44.28 48 45.84V48H32V45.8533C32 44.28 32.9067 42.84 34.3467 42.2133C35.9067 41.52 37.8267 41 40 41ZM29.3333 41.3333C30.8 41.3333 32 40.1333 32 38.6667C32 37.2 30.8 36 29.3333 36C27.8667 36 26.6667 37.2 26.6667 38.6667C26.6667 40.1333 27.8667 41.3333 29.3333 41.3333ZM30.84 42.8C30.3467 42.72 29.8533 42.6667 29.3333 42.6667C28.0133 42.6667 26.76 42.9467 25.6267 43.44C24.64 43.8667 24 44.8267 24 45.9067V48H30V45.8533C30 44.7467 30.3067 43.7067 30.84 42.8ZM50.6667 41.3333C52.1333 41.3333 53.3333 40.1333 53.3333 38.6667C53.3333 37.2 52.1333 36 50.6667 36C49.2 36 48 37.2 48 38.6667C48 40.1333 49.2 41.3333 50.6667 41.3333ZM56 45.9067C56 44.8267 55.36 43.8667 54.3733 43.44C53.24 42.9467 51.9867 42.6667 50.6667 42.6667C50.1467 42.6667 49.6533 42.72 49.16 42.8C49.6933 43.7067 50 44.7467 50 45.8533V48H56V45.9067ZM40 32C42.2133 32 44 33.7867 44 36C44 38.2133 42.2133 40 40 40C37.7867 40 36 38.2133 36 36C36 33.7867 37.7867 32 40 32Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3409_14608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare2);
export default __webpack_public_path__ + "static/media/care2.96740e880aee2b5da13a28be293a58dc.svg";
export { ForwardRef as ReactComponent };